import Sentry from './sentry.import';
import getUserName from '../utils/getUserName';

export const setUserContext = () => {
  Sentry.configureScope((scope) => {
    scope.setUser('email', getUserName());
  });
};
